/** Mulberry32 PRNG factory; seed with any 32-bit uint. */
export function mulberry32(seed) {
  let a = seed >>> 0;
  return function next() {
    a += 0x6d2b79f5;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function createRngFromSeed(seedUint32) {
  const next = mulberry32(seedUint32);
  return {
    /** inclusive 1..sides */
    rollDie(sides) {
      return 1 + Math.floor(next() * sides);
    },
    /** inclusive min..max */
    nextInt(min, max) {
      return min + Math.floor(next() * (max - min + 1));
    },
  };
}

/** @returns {number} unsigned 32-bit */
export function randomSeed() {
  const buf = new Uint32Array(1);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(buf);
    return buf[0];
  }
  return (Math.random() * 0xffffffff) >>> 0;
}

/* U+2680 ⚀ through U+2685 ⚅ */
export function d6Unicode(value) {
  if (value < 1 || value > 6) return String(value);
  return String.fromCodePoint(0x2680 + (value - 1));
}
